import { z } from 'zod/mini'

import { itemObject } from './fields'
import { gtmMetadataShape } from './gtm-metadata'
import { listItemShape } from './item'
import { nonEmptyString } from './non-empty-string'

export const selectItemSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('select_item'),
  ecommerce: z.strictObject({
    // Product price currency, undefined when the product has no price
    currency: z.optional(z.string()),
    // Zone, component, or list name: the list must be identifiable
    item_list_id: nonEmptyString(),
    item_list_name: z.string(),
    // The selected product only
    items: z
      .array(itemObject(listItemShape))
      .check(z.minLength(1), z.maxLength(1)),
  }),
})
